import { render, staticRenderFns } from "./productIndex.vue?vue&type=template&id=1ac13fa6"
import script from "./productIndex.vue?vue&type=script&lang=js"
export * from "./productIndex.vue?vue&type=script&lang=js"
import style0 from "./productIndex.vue?vue&type=style&index=0&id=1ac13fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports